<template>
  <div :class="['button-box', 'align-' + align]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
}
</script>

<style lang="less" scoped>
.button-box {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  font-size: 24px;
  align-items: center;
  >div {
    display: inline-flex;
    flex-wrap: wrap;
  }
  /deep/button[normal] {
    flex-shrink: 0;
    padding: 0;
    width: 160px;
    font-weight: 400;
    line-height: 1;
    margin: 5px 0;
  }
  /deep/.van-button--default[normal] {
    border-color: #999999;
  }
  /deep/.button-active[normal] {
    font-weight: 500;
    background: linear-gradient(90deg, #ff8200 0%, #ff1414 100%);
    color: #ffffff;
    border: 0px;
    &::after, &::before {
      border-width: 0;
    }
  }
}
.align-left {
  /deep/button[normal] {
    margin-right: 10px;
  }
}
.align-right {
  justify-content: flex-end;
  >div {
    justify-content: flex-end;
  }
  /deep/button[normal] {
    margin-left: 10px;
  }
}
</style>
